import { DexResultView } from '@mark43/dex-api';
import { some } from 'lodash';
import { isHit } from '../utils';
import { EntityTypeEnum, FederatedSearchQueryLinkDto } from '@mark43/cad-api';

function getEntityByType(
    federatedQueryLinks: FederatedSearchQueryLinkDto[],
    entityType: string
): FederatedSearchQueryLinkDto | undefined {
    return federatedQueryLinks.find((f) => f.entityType === entityType);
}

export function resultsHaveHit(results: DexResultView[]): boolean {
    if (results.length === 0) {
        return false;
    }
    const childDexResultViews = results.flatMap((result) => {
        return result.childDexResultViews;
    });
    return (
        some(results, (result) => {
            return isHit(result);
        }) || resultsHaveHit(childDexResultViews)
    );
}

export function getFederatedQueryLinks(
    federatedSearchQueryLinkDtos: FederatedSearchQueryLinkDto[] | undefined,
    queryId: string
): FederatedSearchQueryLinkDto[] {
    if (!federatedSearchQueryLinkDtos) {
        return [];
    }
    return federatedSearchQueryLinkDtos.filter((f) => f.federatedQueryId === queryId);
}

export function getUnitCallSignFromFederatedSearchQueryLinks(
    federatedQueryLinks: FederatedSearchQueryLinkDto[]
): string | undefined {
    return getEntityByType(federatedQueryLinks, EntityTypeEnum.UNIT.name)?.label;
}

type AgencyEventFromFederatedSearchQueryLinks = {
    agencyEventId: number | undefined;
    agencyEventNumber: string | undefined;
};

export function getAgencyEventFromFederatedSearchQueryLinks(
    federatedQueryLinks?: FederatedSearchQueryLinkDto[]
): AgencyEventFromFederatedSearchQueryLinks {
    const entity = getEntityByType(federatedQueryLinks ?? [], EntityTypeEnum.CAD_AGENCY_EVENT.name);
    return {
        agencyEventId: entity?.entityId,
        agencyEventNumber: entity?.label,
    };
}
